import React from "react";

function CloudServices() {
  // Array of cloud security services
  const securityServices = [
    "PROTEÇÃO DE APIS",
    "SCAN DE VULNERABILIDADES",
    "POLÍTICAS E GESTÃO DE ACESSOS",
    "MONITORAMENTO E COMPLIANCE",
    "PREVENÇÃO DE AMEAÇAS",
    "DEVSECOPS",
    "PROTEÇÃO DE DADOS",
    "MONITORAMENTO DE EVENTOS DE SEGURANÇA"
  ];

  return (
    <div className="w-full bg-[#040116] pt-24 pb-8">
      <div className="container mx-auto flex flex-col md:flex-row items-center">
        {/* Left section with cloud image (1/3) */}
        <div className="w-full md:w-1/3 ml-24 flex justify-start pl-0 mb-0 scale-140">
          <img 
            src="/assets/cloud.png" 
            alt="Cloud Security" 
            className="w-4/5 max-w-xs"
          />
        </div>
        
        {/* Right section with services (2/3) */}
        <div className="w-full md:w-2/3 grid grid-cols-1 md:grid-cols-2 gap-6 pr-4 md:pr-16">
          {securityServices.map((service, index) => (
            <div key={index} className="flex items-start">
              <img 
                src="/assets/rainbow_arrow.svg" 
                alt="Arrow" 
                className="w-6 h-6 mt-1 mr-3"
              />
              <div>
                <h3 className="text-white text-xl font-inter-regular mt-[1px]">{service}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CloudServices;
